// extracted by mini-css-extract-plugin
export default {"titleview":"index_titleview__JFgu7","img":"index_img__HLSOX","text":"index_text__-VYfC","custom_top_back_white":"index_custom_top_back_white__zIig3"};